import { PERMISSIONS } from '@erp/shared';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWorkTab } from '@/app/work-tabs/work-tab-context';
import { usePermissions } from '@/features/auth';
import { PartnerFormSheet } from '../components/partner-form-sheet';

export function PartnerNewRoute(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { can } = usePermissions();
  const [params] = useSearchParams();
  const requested = params.get('preset');
  const preset = requested === 'prospect' || requested === 'supplier' ? requested : 'customer';
  const tab = useWorkTab({
    title: t(`workTabs.new.${preset}`),
    listPath: `/partners/${preset === 'supplier' ? 'suppliers' : preset === 'prospect' ? 'prospects' : 'customers'}`,
  });
  if (!can(PERMISSIONS.CUSTOMER_WRITE)) return <p role="alert">{t('permissions.deniedTitle')}</p>;
  return (
    <PartnerFormSheet
      open
      inline
      partner={null}
      preset={preset}
      onOpenChange={(open) => {
        if (!open) tab.close();
      }}
      onSaved={(saved) => {
        const path = `/partners/${saved.id}`;
        tab.update({ path, title: saved.displayName, dirty: false });
        navigate(path, { replace: true });
      }}
    />
  );
}
